"use client";

import { FullPageError } from "@/components/page/full-page-error";
import { useEffect } from "react";

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return <FullPageError />;
}
